import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Calculator extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get currency() {
    return get(this, '_currency.value', '');
  }

  // MOBILE SMALL MODAL
  get valueOfOptimisationText() {
    return get(this, '_value_of_optimisation_text.value', '');
  }

  get linkToMoreDataText() {
    return get(this, '_link_to_more_data_text.value', '');
  }

  // MAIN VIEW:
  get mainHeading() {
    return get(this, '_main_heading.value', '');
  }

  get detailsViewLinkText() {
    return get(this, '_details_view_link_text.value', '');
  }

  get returnToMainViewLinkText() {
    return get(this, '_return_to_main_view_link_text.value', '');
  }

  // ICONS MAIN VIEW:
  get conferenceRoomsMainViewIcon() {
    return get(this, '_conference_rooms_main_view_icon.value[0].url', '');
  }

  get employeesMainViewIcon() {
    return get(this, '_employees_main_view_icon.value[0].url', '');
  }

  get desksMainViewIcon() {
    return get(this, '_desks_main_view_icon.value[0].url', '');
  }

  get parkingSpotsMainViewIcon() {
    return get(this, '_parking_spots_main_view_icon.value[0].url', '');
  }

  // LABELS AND INPUTS IN MAIN VIEW:
  get numberOfConferenceRoomsLabel() {
    return get(this, '_number_of_conference_rooms_label.value', '');
  }

  get numberOfConferenceRoomsDefaultValue() {
    return get(this, '_number_of_conference_rooms_default_value.value', 0);
  }

  get monthlyM2RentPriceLabel() {
    return get(this, '_monthly_m2_rent_price_label.value', '');
  }

  get monthlyM2RentPriceDefaultValue() {
    return get(this, '_monthly_m2_rent_price_default_value.value', 0);
  }

  get numberOfEmployeesLabel() {
    return get(this, '_number_of_employees_label.value', '');
  }

  get numberOfEmployeesDefaultValue() {
    return get(this, '_number_of_employees_default_value.value', 0);
  }

  get averageEmployeeSalaryPerHourLabel() {
    return get(this, '_average_employee_salary_per_hour_label.value', '');
  }

  get averageEmployeeSalaryPerHourDefaultValue() {
    return get(this, '_average_employee_salary_per_hour_default_value.value', 0);
  }

  get numberOfDesksLabel() {
    return get(this, '_number_of_desks_label.value', '');
  }

  get numberOfDesksDefaultValue() {
    return get(this, '_number_of_desks_default_value.value', 0);
  }

  get numberOfParkingSpotsLabel() {
    return get(this, '_number_of_parking_spots_label.value', '');
  }

  get numberOfParkingSpotsDefaultValue() {
    return get(this, '_number_of_parking_spots_default_value.value', 0);
  }

  get pricePerParkingSpotLabel() {
    return get(this, '_price_per_parking_spot_label.value', '');
  }

  get pricePerParkingSpotDefaultValue() {
    return get(this, '_price_per_parking_spot_default_value.value', 0);
  }

  // Side info texts:
  get sideInfoOptimisationFrequency() {
    return get(this, '_side_info_optimisation_frequency.value', '');
  }

  get sideInfoOptimisationPeriod() {
    return get(this, '_side_info_optimisation_period.value', '');
  }

  get sideInfoText() {
    return get(this, '_side_info_text_3b26206.value', '');
  }

  get sideInfoImplementationText() {
    return get(this, '_side_info_implementation_text.value', '');
  }

  get sideInfoReimburseText() {
    return get(this, '_side_info_reimburse_text.value', '');
  }

  get asideNote() {
    return get(this, '_aside_note.value', '');
  }

  // ICONS DISPLAYED IN DETAILS VIEW:
  get conferenceRoomsDetailsViewIcon() {
    return get(this, '_conference_rooms_details_view_icon.value[0].url', '');
  }

  get employeesDetailsViewIcon() {
    return get(this, '_employees_details_view_icon.value[0].url', '');
  }

  get desksMainDetailsIcon() {
    return get(this, '_desks_details_view_icon.value[0].url', '');
  }

  get parkingSpotsDetailsViewIcon() {
    return get(this, '_parking_spots_details_view_icon.value[0].url', '');
  }

  // OPTIMISATION RATES REQUIRED FOR CALCULATIONS (DETAILS VIEW):

  get optimisationRatesHeading() {
    return get(this, '_optimisation_rates_heading.value', '');
  }

  get conferenceRoomOptimisationRate() {
    return get(this, '_conference_room_optimisation_rate.value', '');
  }

  get workingHoursOptimisationRate() {
    return get(this, '_working_hours_optimisation_rate.value', '');
  }

  get desksOptimisationRate() {
    return get(this, '_desks_optimisation_rate.value', '');
  }

  get parkingOptimisationRate() {
    return get(this, '_parking_optimisation_rate.value', '');
  }

  // Constant values required for calculations (displayed in details view):

  get averageSizeOfConferenceRoom() {
    return get(this, '_average_size_of_conference_room[0]', {});
  }

  get averageWorkingHoursPerMonth() {
    return get(this, '_average_working_hours_per_month[0]', {});
  }

  get estimatedAreaOfOneDesk() {
    return get(this, '_estimated_area_of_one_desk[0]', {});
  }

  get estimatedCostOfSensorInstallationPerDesk() {
    return get(this, '_estimated_cost_of_sensor_installation_per_desk[0]', {});
  }

  get costOfScreenHardwarePerRoom() {
    return get(this, '_cost_of_screen_hardware_per_room[0]', {});
  }

  get subscriptionFeePerEmployeeIn5Years() {
    return get(this, '_subscription_fee_per_employee_in_5_years[0]', {});
  }

  // Labels for calculated values in details view:
  get hardwareImplementationCostLabel() {
    return get(this, '_hardware_implementation_cost_label.value', '');
  }

  get costOfZoniferoIn5YearsPerspectiveLabel() {
    return get(this, '_cost_of_zonifero_in_5_years_perspective_label.value', '');
  }

  get totalOptimisationPerMonthLabel() {
    return get(this, '_total_optimisation_per_month_label.value', '');
  }

  get yourReturnOfInvestmentTimeLabel() {
    return get(this, '_your_return_of_investment_time_label.value', '');
  }

  get roomsOptimisationLabel() {
    return get(this, '_rooms_optimisation_label.value', '');
  }

  get workOptimisationLabel() {
    return get(this, '_work_optimisation_label.value', '');
  }

  get desksOptimisationLabel() {
    return get(this, '_desks_optimisation_label.value', '');
  }

  get parkingOptimisationLabel() {
    return get(this, '_parking_optimisation_label.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Calculator.model.js